import React, { Component } from "react";
import Geosuggest from "react-geosuggest";
import "./Geosuggest.css";

class AutoFillAddress extends Component {
  /*
  Note: Validation of AutoFillAddress happens, when user clicks on the dropdown suggestions
  the typed text is not considered as value
  */
  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.geosuggest.update(nextProps.value);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.initialValue != this.props.initialValue) {
      return true;
    }
    return true;
  }

  onBlur = address => {
    if (address !== null) {
      if (this.props.onBlur) {
        this.props.onBlur(address);
      }
      this.validateAddress(address);
    }
  };

  validateAddress = address => {
    this.geosuggest.update(address.trim());
  };

  render() {
    const { ...geoSuggestProps } = this.props;
    return (
      <Geosuggest
        ref={node => {
          this.geosuggest = node;
        }}
        {...geoSuggestProps}
        onBlur={this.onBlur}
      />
    );
  }
}

export default AutoFillAddress;



// WEBPACK FOOTER //
// ./src/components/AutoFillAddress/index.js